Engravings.createCapEngravingPreview = function(view) {
  let userText = view.userText
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  var svgNS = svg.namespaceURI;
  
  var path = document.createElementNS(svgNS,'path');
  path.setAttribute('id', 'curvedTextPath');
  path.setAttribute('transform','rotate(90, 78, 78)');
  
  var circle = document.createElementNS(svgNS,'circle');
  circle.setAttribute('cx', '78');
  circle.setAttribute('cy', '78');
  circle.setAttribute('r', '74.5');
  circle.setAttribute('id', 'mainCircle');
  circle.setAttribute('fill', 'none');
//   circle.setAttribute('stroke', '#ffff00');
//   circle.setAttribute('stroke-width', '0.4');
  
  var text = document.createElementNS(svgNS,'text');
  var textPath = document.createElementNS(svgNS,'textPath');
  
  textPath.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#curvedTextPath');

  textPath.textContent = userText != "" ? userText : 'Type your text!';

  path.setAttribute('d', 'M 78, 78 m -59, 0 a 59, 59 0 1, 0 118, 0 a 59, 59 0 1, 0 -118, 0');
  textPath.setAttribute('startOffset', '50.5%');

  switch(view.selectedFontName) {

    case 'IvyMode':
  	  textPath.setAttribute('font-family', 'IvyMode');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '4' : '3');
      textPath.setAttribute('font-size', Engravings.textSizeAleo(userText));
      break;
    case 'Aleo':
  	  textPath.setAttribute('font-family', 'Aleo');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '4' : '3');
      textPath.setAttribute('font-size', Engravings.textSizeAleo(userText));
      break;
    case 'Sinter':
  	  textPath.setAttribute('font-family', 'Sinter');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '4' : '3');
      textPath.setAttribute('font-size', Engravings.textSizeAleo(userText));
      break;
    case 'Caveat Regular':
  	  textPath.setAttribute('font-family', 'Caveat');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '3' : '2');
      textPath.setAttribute('font-size', Engravings.textSizeCaveat(userText));
      break;
    case 'Caveat Bold':
  	  textPath.setAttribute('font-family', 'Caveat');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '3' : '2');
      textPath.setAttribute('font-weight', 'bold');
      textPath.setAttribute('font-size', Engravings.textSizeCaveat(userText));
      break;
    case 'Moonbright':
  	  textPath.setAttribute('font-family', 'Moonbright');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '3' : '2');
      textPath.setAttribute('font-size', Engravings.textSizeMoonbright(userText));
      break;
    case 'Cheddar Jack':
  	  textPath.setAttribute('font-family', 'CheddarJack');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '2' : '1.3');
      textPath.setAttribute('font-size', Engravings.textSizeJack(userText));
      break;
    case 'Poppins':
  	  textPath.setAttribute('font-family', 'Poppins');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '3' : '2');
      textPath.setAttribute('font-size', Engravings.textSizeAleo(userText));
      break;
    case 'Amertha':
  	  textPath.setAttribute('font-family', 'Amertha');
  	  textPath.setAttribute('letter-spacing', Engravings.isMostlyUpper(userText) ? '3' : '2');
      textPath.setAttribute('font-size', Engravings.textSizeAmertha(userText));
      break;
      
  }

  var pageTitle = $('.page-title').text().toUpperCase().trim();
  
  if (pageTitle == 'GRAPHITE BY SNYR') {
  	textPath.setAttribute('stroke', '#938b83');
    textPath.setAttribute('fill', '#938b83');
  } else {
  	textPath.setAttribute('stroke', '#3A2C25');
    textPath.setAttribute('fill', '#3A2C25');
  }

  svg.appendChild(circle);
  svg.appendChild(path);
  text.appendChild(textPath);
  svg.appendChild(text);

  view.$engravingContainer.append(svg);
}

Engravings.isMostlyUpper = function(text) {
  return text.replace(/[^A-Z]/g, "").length / text.length > 0.7;
}
  
Engravings.textSizeAleo = function(text) {
  textLength = text.length;
  if (textLength < 22){
    return 21
  } else if (textLength < 27) {
    return 21
  } else if (textLength < 29) {
    return 21
  } else {
    return 20
  }
}

Engravings.textSizeCaveat = function(text) {
  textLength = text.length;
  if (textLength < 25){
    return 22
  } else if (textLength < 27) {
    return 20
  } else {
    return 18
  }
}

Engravings.textSizeAmertha = function(text) {
  textLength = text.length;
  if (textLength < 20){
    return 25
  } else {
    return 22
  }
}

Engravings.textSizeJack = function(text) {
  textLength = text.length;
  if (textLength < 27){
    return 29
  } else if (textLength < 29) {
    return 27
  } else {
    return 26
  }
}


Engravings.textSizeMoonbright = function(text){
  return 27;
}